import React from 'react';
import './Toast.css'; // Add this for custom styling

const Toast = ({ message, onUpdate, onClose }) => {
    return (
        <div className="toast-container">
            <div className="toast-message">{message}</div>
            <div className="toast-actions">
                <button className="toast-button update-button" onClick={onUpdate}>
                    Update Now
                </button>
                <button className="toast-button close-button" onClick={onClose}>
                    Close
                </button>
            </div>
        </div>
    );
};

export default Toast;
